var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.287,
    height: 25.287,
    viewBox: "0 0 25.287 25.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook-square",
    "data-name": "Icon awesome-facebook-square",
    d: "M22.578,2.25H2.709A2.709,2.709,0,0,0,0,4.959V24.828a2.709,2.709,0,0,0,2.709,2.709h7.747v-8.6H6.9V14.894h3.556V11.809c0-3.508,2.088-5.446,5.287-5.446a21.543,21.543,0,0,1,3.134.273V10.08H17.112a2.023,2.023,0,0,0-2.281,2.186v2.627h3.882l-.621,4.047H14.831v8.6h7.747a2.709,2.709,0,0,0,2.709-2.709V4.959A2.709,2.709,0,0,0,22.578,2.25Z",
    transform: "translate(0 -2.25)",
    fill: "#E6E7EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookGrey);
export default __webpack_public_path__ + "static/media/FacebookGrey.ad2ae0a7876f41cc591067f05496bd7d.svg";
export { ForwardRef as ReactComponent };